import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=2c6fcb12&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=2c6fcb12&lang=scss&scoped=true&"
import style1 from "./Details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6fcb12",
  null
  
)

export default component.exports